// Name10 
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'
import { LucideIcon, Button, message, useCRUDController, Name1 } from './ot.jsx'
import BaseDocumentResponseCanvasEditModal from './base_document_response_canvas_edit_modal.jsx';
import BaseCashRealTimeModal from './base_cash_real_time_modal.jsx';
import BaseCashRefundModal from './base_cash_refund_modal.jsx';
import BaseCashManagementModal from './base_cash_management_modal.jsx';
import BaseCashHistoryModal from './base_cash_history_modal.jsx';


const Name10 = ({
    dbCoverIdName = "process_document_id",
    tabDocumentResponseApiRoute = '/access_control_management/backend/access_control/response',
    tabDocumentApiRoute = '/access_control_management/backend/access_control_document/overview',
    baseCardView1_2PropsSrc = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKFSgdhQvBlZO6I8s-jtKIYOED1NqEs4xEjA&s",
    propsCategoryName = "設備",
    propsCategoryTitle = "資訊",
    propsAxiosMode = "patch",
    baseInfoView3_1Props = { showAllLabel: true },
    propsToolbars = ['patch', "response_delete"],  // 預設顯示 patch 和 response_delete 的工具列按鈕，其餘還有 test 
    propsStateMode = 'form_value',
    propsToolBar = ['post'],
    propsPostRecord,// 這個是用來新增時帶入表單的預設值，會在點擊新增按鈕時設定到 record state，然後打開表單 modal  
    propsDefaultAllTab = false,
    propsShowTabs = true,
    processResponseData,
    showCreateButtontext = true,
    pageTitle = "管理首頁",
    cashRealTimeApiRoute = "/cash_management/backend/record_document/view",
    reponseApiRoute,
    propsLoadRecord,
    ...props
}) => {
    const [axiosMode, setAxiosMode] = useState(propsAxiosMode) // "post" or "patch"
    const [reloadCount, setReloadCount] = useState(0)
    const [reloadAndResetCount, setReloadAndResetCount] = useState(0)
    const { t } = useTranslation("translation", { keyPrefix: "/ad_plan/form_static/_4" })

    const [tabsData, setTabsData] = useState([
        {
            key: "",
            label: t("全部"),
        }
    ])
    const [openFormModal, setOpenFormModal] = useState(false)
    const [openCashRealTimeModal, setOpenCashRealTimeModal] = useState(false)
    const [openCashRefundModal, setOpenCashRefundModal] = useState(false)
    const [openCashManagementModal, setOpenCashManagementModal] = useState(false)
    const [openCashHistoryModal, setOpenCashHistoryModal] = useState(false)
    const [record, setRecord] = useState(null)
    const [currentDocumentId, setCurrentDocumentId] = useState(null)
    const getTabs = () => {
        TabDocumentController.getData({})
            .then((response) => {
                let data = response?.data || []
                let newTabsData = data.map((item) => {
                    return {
                        key: item?.document_id,
                        label: item?.document_name || t("未命名"),
                        total: "0/0", // 雙數字
                        badgeClassname: "bg-[#8d96f9]/75 text-[#8d96f9]",
                        apiRoute: tabDocumentResponseApiRoute + '?document_id=' + item?.document_id
                    }
                })
                setTabsData(newTabsData)
            })
    }
    const getParams = (keyArr, categoryDataValue) => {
        setCurrentDocumentId(propsDefaultAllTab ? undefined : keyArr?.[0])

        return {
            document_id: propsDefaultAllTab ? undefined : keyArr?.[0]
        }
    }
    const TabDocumentController = useCRUDController({
        apiRoute: tabDocumentApiRoute,
        onBefore: ({ axiosMode }) => {
            if (axiosMode !== "get") {
                // setLoading(true);
            }
        },
        onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                if (axiosMode === "post") {
                    message.success(t("新增成功"))
                    // setReloadAndResetCount((pre) => pre + 1)
                } else if (axiosMode === "patch") {
                    message.success(t("修改成功"))
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.success(t("刪除成功"))
                    // setReloadAndResetCount((pre) => pre + 1)

                }
            }
            else if (status === "error") {
                if (axiosMode === "post") {
                    message.error(t("新增失敗"))
                    // setReloadAndResetCount((pre) => pre + 1)

                }
                else if (axiosMode === "patch") {
                    message.error(t("修改失敗"))
                    // setReloadCount((pre) => pre + 1)
                }
                else if (axiosMode === "delete") {
                    message.error(t("刪除失敗"))
                    // setReloadAndResetCount((pre) => pre + 1)
                }
            }
            if (axiosMode !== "get") {
                // setLoading(false)
                // setModalOpen(false);
            }
        }
    })
    useEffect(() => {
        if(propsShowTabs)
            getTabs()
    }, [])
    return <>
  
        <BaseDocumentResponseCanvasEditModal
            title={axiosMode === 'post' ? t('新增') + propsCategoryName + propsCategoryTitle: t('編輯') + propsCategoryName + propsCategoryTitle}
            axiosMode={axiosMode}
            open={openFormModal}
            setOpen={setOpenFormModal}
            record={{ document_id: currentDocumentId, ...record }}
            onFinish={({ axiosMode, status, values }) => {
                if (status === "success" && axiosMode === "patch") {
                    setReloadCount((pre) => pre + 1) 
                    if(props?.propsSetReloadCount){
                        props?.propsSetReloadCount((pre) => pre + 1)
                    }
                }
                else if (status === "success" && axiosMode === "post") {
                    setReloadAndResetCount((pre) => pre + 1)
                    if(props?.setReloadAndResetCount){
                        props?.propsSetReloadAndResetCount((pre) => pre + 1)
                    }
                }
                if (axiosMode !== "get") {
                    setOpenFormModal(false)
                }
            }}
            documentApiRoute={tabDocumentApiRoute}
            processResponseData={processResponseData}
            reponseApiRoute={reponseApiRoute}
            propsLoadRecord={propsLoadRecord}
        />
        <BaseCashRealTimeModal
            title={t("即時詳細資訊")}
            axiosMode={axiosMode}
            open={openCashRealTimeModal}
            setOpen={setOpenCashRealTimeModal}
            
            record={{ document_id: currentDocumentId, ...record }}
            realTimeApiRoute={cashRealTimeApiRoute}   // ⭐ 新增 API 傳遞

            onFinish={({ axiosMode, status, values }) => {
                setOpenCashRealTimeModal(false)
            }}
            documentApiRoute={tabDocumentApiRoute}
            processResponseData={processResponseData}
        />
        <BaseCashRefundModal
            title={t("退款詳細資訊")}
            axiosMode={axiosMode}
            open={openCashRefundModal}
            setOpen={setOpenCashRefundModal}
            
            record={{ document_id: currentDocumentId, ...record }}
            realTimeApiRoute={cashRealTimeApiRoute}   // ⭐ 新增 API 傳遞
            
            onFinish={({ axiosMode, status, values }) => {
                setOpenCashRefundModal(false)
            }}
            documentApiRoute={tabDocumentApiRoute}
            processResponseData={processResponseData}
        />
        <BaseCashManagementModal
            title={t("詳細資訊")}
            axiosMode={axiosMode}
            open={openCashManagementModal}
            setOpen={setOpenCashManagementModal}
            
            record={{ document_id: currentDocumentId, ...record }}
            realTimeApiRoute={cashRealTimeApiRoute}   // ⭐ 新增 API 傳遞
            
            onFinish={({ axiosMode, status, values }) => {
                setOpenCashManagementModal(false)
            }}
            documentApiRoute={tabDocumentApiRoute}
            processResponseData={processResponseData}
        />
        <BaseCashHistoryModal
            title={t("詳細資訊")}
            axiosMode={axiosMode}
            open={openCashHistoryModal}
            setOpen={setOpenCashHistoryModal}
            
            record={{ document_id: currentDocumentId, ...record }}
            realTimeApiRoute={cashRealTimeApiRoute}   // ⭐ 新增 API 傳遞
            
            onFinish={({ axiosMode, status, values }) => {
                setOpenCashHistoryModal(false)
            }}
            documentApiRoute={tabDocumentApiRoute}
            processResponseData={processResponseData}
        />
        <Name1
            // propsGetBaseCardViewData={getBaseCardViewData}
            // propsGetBaseListViewData={getBaseListViewData}
            categoryData={tabsData}
            showBaseInfoView3={false}
            baseInfoView3_1Props={baseInfoView3_1Props}
            propsGetParams={getParams}
            showComponent={[
                "BaseInfoView1",
                "BaseInfoView2",
                "BaseInfoView3",
                // "BaseInfoView4",
                "BaseInfoView5",
                "BaseInfoView6",
                // "BaseTreeSelector"
            ]}
            propsReloadCount={reloadCount}
            propsReloadAndResetCount={reloadAndResetCount}
            propsSetReloadAndResetCount={setReloadAndResetCount}
            propsSetReloadCount={setReloadCount}
            toolBarRender={() => [
                ...(propsToolBar.includes('post') ? [<Button
                    onClick={() => {
                        setRecord(propsPostRecord || null)
                        setOpenFormModal(true)
                        setAxiosMode("post")
                    }}
                >
                    <LucideIcon name={"Plus"} className="h-4 w-4 mr-1" />
                    {t('新增')}{propsCategoryName}
                </Button>] : [])
            ]}
            propsToolbars={propsToolbars}
            propsStateMode={propsStateMode}
            setRecord={setRecord}
            setOpenFormModal={setOpenFormModal}
            setAxiosMode={setAxiosMode}
            processResponseData={processResponseData}
            mainApiRoute={tabDocumentApiRoute}
            showCreateButtontext={showCreateButtontext}
            pageTitle={pageTitle}
            setOpenCashRealTimeModal={setOpenCashRealTimeModal}
            setOpenCashRefundModal={setOpenCashRefundModal}
            setOpenCashManagementModal={setOpenCashManagementModal}
            setOpenCashHistoryModal={setOpenCashHistoryModal}
            {...props}

        />
    </>
}
export default Name10
